import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table} from 'react-bootstrap';
import swal from 'sweetalert';
import Notifications, {notify} from 'react-notify-toast';
import moment from 'moment';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import SvgIcon from 'react-icons-kit';
import {pencil2} from 'react-icons-kit/icomoon/pencil2';
import {bin} from 'react-icons-kit/icomoon/bin';
import {print} from 'react-icons-kit/fa/print';
import { search } from 'react-icons-kit/icomoon/search';
import ModalDetails from './modalDetails';
import Help from '../../generics/help';

var Config = require('../../../config');
var session = sessionStorage.getItem('health_facilities_name');

class AlicuotsList extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.getList = this.getList.bind(this);
		this.newEntry = this.newEntry.bind(this);
		this.openDetails = this.openDetails.bind(this);

		var aux_date = new Date();
		this.state = {
			filterText:"",
			start_date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			end_date: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			list:[],
			columns:[],
		}
	}

	componentDidMount(){
		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=ALICUOTS',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => {
      		if(response.ok){
      			return response.json();
      		}else{
      			response.text().then((msg)=>{
      				swal('Error', msg, 'error');
      			});
      		}   		
      	}).then(response => {
        	if(response !== undefined){

          		this.setState({ columns: response });
        	}
      	});

		this.getList();
	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	getList(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'alicuots_process?start_date='+this.state.start_date+
			'&end_date='+this.state.end_date+'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
  			method : 'get',
  			headers: new Headers({
  				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
  				'Accept'		: 'application/json',
  				'Content-Type'	: 'application/json'
  			})
  		}).then(res => {
  			this.props.waiting.handleClose();
  			if(res.ok){
  				return res.json();
  			}else{
  				return res.text()
  			}
  		})
  		.then(response=>{
  			if(response !== undefined){
  				this.setState({list:response});
  			}else{
  				swal("Error", response, 'error');
	  		}	
  		})
	}

	newEntry(){
		this.props.history.push("/aliquots/new");
	}

	filter(row){
		var res = true;

		if(row !== null){
			if(
				row.unit_number !== null &&
				row.component !== null 
			){
				if(
					row.unit_number.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.component.indexOf(this.state.filterText.toUpperCase()) !== -1 
					
				){
					res = true;
				}else{
					res = false;
				}
			}
		}

		return res;
	}

	openDetails(e, id){
		this.modal_details.handleShow(id)
	}

	onDelete(id){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, function (isConfirm) {
	        if (isConfirm) {
	        	this.props.waiting.handleShow('Cargando...');
				fetch(Config.default.apiGateway.URL+'alicuots_process/'+id, {
		  			method : 'delete',
		  			headers: new Headers({
		  				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
		  				'Accept'		: 'application/json',
		  				'Content-Type'	: 'application/json'
		  			})
		  		}).then(res => {
		  			this.props.waiting.handleClose();
		  			if(res.ok){
		  				return res.json();
		  			}else{
		  				res.text().then((msg)=>{
		  					swal("Error", msg, 'error');
		  				})
		  			}
		  		})
		  		.then(response=>{
		  			if(response !== undefined){
		  				this.getList();
		  				swal('Success', 'El registro se elimino correctamente', 'success');
		  			}	
		  		})
	        }
	    }.bind(this));
	}

	

	render(){
		const {t} = this.props;

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.process.MAIN')} ->
						{t('sidebar.nav.process.aliquots.MAIN')}

					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_processed"} 
	                submenu={"help_alicuots"}  />
				<form noValidate>
					<div className="col-xs-12">
						<div className="col-xs-12 col-md-3" style={{padding:'0'}}>
				            <div className="col-xs-12 col-sm-5">
				            	<span className="span-min">Mostrar Desde</span>
				            </div>
				            <div className="col-xs-12 col-sm-7">
				              <input className="form-control" type="date" name="start_date" value={this.state.start_date}
				                onChange={this.handleChange}/>
				            </div>
				        </div>
				        <div className="col-xs-12 col-md-3">
				            <div className="col-xs-12 col-sm-5">
				            	<span className="span-min">Mostrar Hasta</span>
				            </div>
				            <div className="col-xs-12 col-sm-7">
				              <input className="form-control" type="date" name="end_date" value={this.state.end_date}
				                onChange={this.handleChange}/>
				            </div>
				        </div>

						<div className="col-xs-12 col-sm-4">
							<button type="button" className="btn btn-info" onClick={this.getList} 
								style={{fontSize:"14px", marginRight:"5px"}}
								>
								Buscar
							</button>
							<button type="button" className="btn btn-info" onClick={this.newEntry} 
								style={{fontSize:"14px"}}
								disabled={!this.props.task_alicuots.create}>
								Nuevo
							</button>
						</div>

						
					</div>
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-3">
							<input type="text" className="form-control" placeholder="Filtro..." name="filterText" 
								id="filterText" value={this.state.filterText} onChange={this.handleChange} />
						</div>
					</div>
					<div className="col-xs-12">
						<Table responsive hover>
							<thead>
								<tr>
									<th hidden={this.showColumn('UNIT_NUMBER')}>No. Unidad</th>
									<th hidden={this.showColumn('COMPONENT')}>Componente</th>
									<th hidden={this.showColumn('DATE')}>Fecha</th>
									<th hidden={this.showColumn('ALICUOTS')}>Alicuotas</th>
									<th hidden={this.showColumn('CONTROLS')}></th>
								</tr>
							</thead>
							<tbody>
								{this.state.list.map((l, i)=>(
									this.filter(l) ?
										<tr key={i}>
											<td hidden={this.showColumn('UNIT_NUMBER')}>{l.unit_number}</td>
											<td hidden={this.showColumn('COMPONENT')}>{l.component}</td>
											<td hidden={this.showColumn('DATE')}>
												{moment(l.date).format('DD/MM/YYYY')}
											</td>
											<td hidden={this.showColumn('ALICUOTS')}>
												{l.parts.map((p)=>(
													p.fraction_number+' ('+p.volume+' ml), '
												))}
											</td>
											<td hidden={this.showColumn('CONTROLS')}>
							                    <FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
													iconStyle={{height: 33, width: 33}} 
													onClick={this.onDelete.bind(this, l.origin_id)}
													disabled={!this.props.task_alicuots.delete}>
													<SvgIcon icon={bin} className="icon-align" />
												</FloatingActionButton>
											</td>
										</tr>
									:null
								))}
							</tbody>
						</Table>
					</div>
				</form>

				<ModalDetails {...this.props} onRef={ref => (this.modal_details = ref)} />
				<Notifications />
			</div>
		)
	}
}

export default translate('translations')(AlicuotsList);